module.exports = __webpack_public_path__ + "img/dark-samus-min.a01ba4da.png";